import { CartActionType, CartAction } from '../actions/CartActions';
import { PackageCart } from '../types/api/cart/PackageCart';
import { Nullable } from '../types/custom/Nullable';

export interface CartState {
    activeCart: {
        data: Nullable<PackageCart>,
        error: unknown,
        loading: boolean
    },
    cartPanel: {
        opened: boolean
    }
}

const INITIAL_STATE: CartState = {
    activeCart: {
        data: null,
        error: null,
        loading: false
    },
    cartPanel: {
        opened: false,
    }
};

export default function(state = INITIAL_STATE, action: CartAction): CartState {
    switch(action.type) {
        case CartActionType.FETCH_CART:
            return {
                ...state,
                activeCart: {
                    data: null,
                    error: null,
                    loading: true
                }
            };
        case CartActionType.FETCH_CART_SUCCESS:
            return {
                ...state,
                activeCart: {
                    data: action.payload,
                    error: null,
                    loading: false                
                }
            };
        case CartActionType.TOGGLE_CART: {
            const opened = state.cartPanel.opened;
            return {
                ...state,
                cartPanel: {
                    opened: !opened
                }
            };
        }
        default:
            return state;
    }
}